module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/pretty-check/pretty-check.component.scss
// module id = ./src/app/features/pretty-check/pretty-check.component.scss
// module chunks = main